import Vue from "vue";
import VueRouter from "vue-router";

import { Routes } from "@/constants";

import Home from "@/views/HomeView.vue";
import QuizView from "@/views/QuizView.vue";
import ResultView from "@/views/ResultView.vue";
import RegisterView from "@/views/RegisterView.vue";
import CompletionView from "@/views/CompletionView.vue";
import Loading from "@/views/Loading.vue";
import Page404 from "@/views/Page404.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: Routes.loading.path,
    name: Routes.loading.name,
    component: Loading
  },
  {
    path: Routes.home.path,
    name: Routes.home.name,
    component: Home
  },
  {
    path: Routes.quiz.path,
    name: Routes.quiz.name,
    component: QuizView
  },
  {
    path: Routes.result.path,
    name: Routes.result.name,
    component: ResultView
  },
  {
    path: Routes.register.path,
    name: Routes.register.name,
    component: RegisterView
  },
  {
    path: Routes.completion.path,
    name: Routes.completion.name,
    component: CompletionView
  },
  {
    path: Routes.not_found.path,
    name: Routes.not_found.name,
    component: Page404
  }
];

const router = new VueRouter({
  // mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
